export default function isTokenValid() {
  const expiresAt = localStorage.getItem('expiration');
  if (!expiresAt) return false;

  const expiryTime = Date.parse(expiresAt); // parses ISO string to timestamp
  if (isNaN(expiryTime)) return false;

  return Date.now() < expiryTime;
}
